import React, {useEffect, useState} from "react";
import styled from "styled-components";
import Button from "@components/common/Button";
import useSWR from "swr";
import {useAppEditorStore} from "../../app/store/appEditorStore";
import {ModalBody} from "./Modal";

const CommonConnectedPrdModal = ({handleCloseModal, modalDepth}) => {
    const [hoverViewText, setHoverViewText] = useState(false);
    const [offset, setOffset] = useState(0);
    const [productCount, setProductCount] = useState(0);
    const [productList, setProductList] = useState([]);
    const appEditorStore = useAppEditorStore();
    const commonBoardOriginId = appEditorStore.commonBoardEditorModal.state ? appEditorStore.commonBoardEditorModal.data._id : appEditorStore.boardCommentMap.selector.replace('.common-', '')
    const {
        data: commonBoardLinkedProducts, error, isLoading, mutate
    } = useSWR(commonBoardOriginId ? `/product/linked?commonBoardOrigin=${commonBoardOriginId}&offset=${offset}` : null);

    useEffect(() => {
        if (!isLoading && commonBoardLinkedProducts) {
            setProductCount(commonBoardLinkedProducts.data.productCount)
            setProductList(commonBoardLinkedProducts.data.products);
        }
    }, [commonBoardLinkedProducts]);
    const clickClose = () => {
        handleCloseModal(modalDepth);
    }

    const textMouseHover = (e) => {
        //e.target.offsetWidth
        if (e.target.children[0]) {
            if (e.target.children[0].offsetWidth > 296) {
                setHoverViewText(true);
            }
        }
    }

    const textMouseOut = () => {
        setHoverViewText(false);
    }
    return (
        <ModalBody id={"ConnectProductBoardModal"}>
            <EditConnectProductBoardWrap className={"modal-container"}>
                <TableContentWrap>
                    <colgroup>
                        <col width={"90px"}/>
                        <col width={"296px"}/>
                        <col width={"110px"}/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th>No</th>
                        <th>상품명</th>
                        <th>상품 번호</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        productList && productList.length > 0 ?
                            productList.map(product => (
                                <tr>
                                    <td>{product.no}</td>
                                    <td>
                                        <div
                                            onMouseEnter={textMouseHover}
                                            onMouseLeave={textMouseOut}
                                        ><span>{product.productName}</span>
                                        </div>
                                    </td>
                                    <td>{product.productNo}</td>
                                </tr>
                            ))
                            : <tr className={'no-data'}>
                                <td colSpan={3}>현재 연결된 상품이 없습니다.</td>
                            </tr>
                    }
                    </tbody>
                </TableContentWrap>

                <div className={"modal-close"}>
                    <Button
                        size={"xl"}
                        text={"닫기"}
                        onClickFunc={clickClose}
                    />
                </div>

            </EditConnectProductBoardWrap>
        </ModalBody>
    );
};


const TableContentWrap = styled.table`
    width: 100%;
    height: calc(100% - 64px);

    thead {
        tr {
            th {
                height: 40px;
                vertical-align: middle;

                border-top: 1px solid #EEE;
                border-bottom: 1px solid #EEE;
                background: #FAFAFA;
                color: #555;
                text-align: center;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: -0.12px;
            }
        }


    }

    tbody {
        tr {
            border-bottom: 1px solid #EEE;

            td {
                height: 44px;
                color: #262626;
                text-align: center;
                font-size: 13px;
                font-weight: 400;
                letter-spacing: -0.13px;
                vertical-align: middle;
                position: relative;

                > div {
                    width: 296px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

        .no-data {
            color: #cccccc;

            td {
                color: inherit;
            }
        }
    }
`;
const EditConnectProductBoardWrap = styled.div`
    background-color: #fff;
    height: 100%;
    padding: 32px;

    .modal-close {
        padding: 16px 0;
        display: flex;
        justify-content: center;

        > button {
            color: #fff;
            background-color: #262626;
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
        }
    }
`;


export default CommonConnectedPrdModal;
